//
import { put, takeLatest, call } from 'redux-saga/effects'
import {
  applicationFetchUpdateSuccess,
  applicationInstallUpdateSuccess,
  applicationFetchUpdate,
  applicationCheckVersionValidVersion,
  applicationCheckVersionInvalidVersion,
} from 'core/actions'
import { getToggles } from 'quick-quote/feature-toggles'
import { INITIALISE_APPLICATION_SUCCESS } from 'quick-quote/actions'
import { setNotificationMessage } from 'quick-quote/notification/actions'

import { APPLICATION_FETCH_UPDATE, APPLICATION_CHECK_VERSION } from './action-types'
import { checkVersionNativeApp } from '../deploy-env/app-config'
import { updateCheckNativeAppVersionUser } from 'identity/actions'
import { IsRealDevice } from 'e-submission/utils'

export function* startFetchApplicationUpdate() {
  if (!window.chcp) {
    return
  }

  yield put(applicationFetchUpdateSuccess())
  yield put(applicationInstallUpdateSuccess())
}

export function* startCheckversion() {
  if (getToggles().ENABLE_CHECK_TARGET_VERSION && IsRealDevice) {
    try {
      const err = yield call(checkVersionNativeApp)

      if (!err) {
        yield put(applicationCheckVersionValidVersion())
        yield put(updateCheckNativeAppVersionUser())
      } else {
        yield put(applicationCheckVersionInvalidVersion(err))
        yield put(
          setNotificationMessage({
            type: 'CheckVersionNative',
          })
        )
      }
    } catch (error) {
      yield put(applicationCheckVersionInvalidVersion(error))
      yield put(
        setNotificationMessage({
          type: 'CheckVersionNative',
        })
      )
    }
  }
}

export function* onAppInitSuccess() {
  if (getToggles().ENABLE_CORDOVA_STARTUP_UPDATE_PROGRESS && window.chcp) {
    yield put(applicationFetchUpdate())
  }
}

export default function*() {
  yield [takeLatest(APPLICATION_FETCH_UPDATE, startFetchApplicationUpdate)]
  yield [takeLatest(INITIALISE_APPLICATION_SUCCESS, onAppInitSuccess)]
  yield [takeLatest(APPLICATION_CHECK_VERSION, startCheckversion)]
}
